/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Scene_Change_Detection_Thumbnail_Progress_StatusInputs */

const en_scene_change_detection_thumbnail_progress_status = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generating marker thumbnails ${i?.current}/${i?.total}`)
};

const fr_scene_change_detection_thumbnail_progress_status = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Génération des vignettes de marqueurs ${i?.current}/${i?.total}`)
};

const de_scene_change_detection_thumbnail_progress_status = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Marker-Miniaturbilder werden erstellt ${i?.current}/${i?.total}`)
};

const it_scene_change_detection_thumbnail_progress_status = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generazione miniature dei marcatori ${i?.current}/${i?.total}`)
};

const ru_scene_change_detection_thumbnail_progress_status = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Создание миниатюр маркеров ${i?.current}/${i?.total}`)
};

const es_scene_change_detection_thumbnail_progress_status = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generando miniaturas de marcadores ${i?.current}/${i?.total}`)
};

const zh_cn2_scene_change_detection_thumbnail_progress_status = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在生成标记缩略图 ${i?.current}/${i?.total}`)
};

const ja_scene_change_detection_thumbnail_progress_status = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マーカーサムネイルを生成中 ${i?.current}/${i?.total}`)
};

const hi_scene_change_detection_thumbnail_progress_status = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`मार्कर थंबनेल बनाए जा रहे हैं ${i?.current}/${i?.total}`)
};

const pt_pt2_scene_change_detection_thumbnail_progress_status = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A gerar miniaturas dos marcadores ${i?.current}/${i?.total}`)
};

/**
* | output |
* | --- |
* | "Generating marker thumbnails {current}/{total}" |
*
* @param {Scene_Change_Detection_Thumbnail_Progress_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_thumbnail_progress_status = /** @type {((inputs: Scene_Change_Detection_Thumbnail_Progress_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Thumbnail_Progress_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_thumbnail_progress_status(inputs)
	if (locale === "de") return de_scene_change_detection_thumbnail_progress_status(inputs)
	if (locale === "it") return it_scene_change_detection_thumbnail_progress_status(inputs)
	if (locale === "ru") return ru_scene_change_detection_thumbnail_progress_status(inputs)
	if (locale === "es") return es_scene_change_detection_thumbnail_progress_status(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_thumbnail_progress_status(inputs)
	if (locale === "ja") return ja_scene_change_detection_thumbnail_progress_status(inputs)
	if (locale === "hi") return hi_scene_change_detection_thumbnail_progress_status(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_thumbnail_progress_status(inputs)
	return en_scene_change_detection_thumbnail_progress_status(inputs)
});